import route from '@router/route';
import { RouteGroup } from '@router/types';
import { storeDocumentView } from '@api/gateway/legacy-api/document';

/**
 * Returns route for redirecting after user logs in or registers.
 * In some cases we want the user to be redirected to the dashboard instead of the original entry point.
 * For testing purposes this will only be the case for users with even userIds.
 * Example of a registrationEntryPoint string: '/en/flashcards/population-genetics/11805'
 */
export function determineRedirectAfterAuth(userId: number, registrationEntryPoint: string | null): string {
    const dashboardRoute = route('dashboard.show');
    let entryPoint = registrationEntryPoint;

    if (entryPoint?.includes('companies-search')) {
        entryPoint = dashboardRoute;
    }

    if (userId % 2 !== 0) {
        return entryPoint ?? dashboardRoute;
    }

    if (!entryPoint) {
        return dashboardRoute;
    }

    const pathArray = entryPoint.split('/');
    const path = pathArray[2];

    if (path === RouteGroup.DOC) {
        // we need to store the document view so that the user will have the document in their last viewed widget
        storeDocumentView(pathArray[4]);
        return dashboardRoute;
    }

    // needs to be implemented in the backend first
    // if (path === RouteGroup.FLASHCARDS) {
    //     return dashboardRoute;
    // }

    return entryPoint ?? dashboardRoute;
}
